module.exports = __webpack_public_path__ + "static/media/logo.ee6c0bd9.svg";